import { render, staticRenderFns } from "./priceList.vue?vue&type=template&id=4f510433&scoped=true&"
import script from "./priceList.vue?vue&type=script&lang=js&"
export * from "./priceList.vue?vue&type=script&lang=js&"
import style0 from "./priceList.vue?vue&type=style&index=0&id=4f510433&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f510433",
  null
  
)

export default component.exports